import React, { useState, useEffect } from "react";
import { Button, Box } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set up scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        zIndex: 995,
        transition: "opacity 0.3s",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
      }}
    >
      <Button
        aria-label="Back to top"
        variant="contained"
        onClick={scrollToTop}
        sx={{
          backgroundColor: "#c4d4e0",
          "&:hover": {
            backgroundColor: "#848d94",
          },
          width: "50px",
          height: "50px",
          minWidth: "unset",
          borderRadius: 0,
          clipPath: "polygon(70% 0, 100% 30%, 100% 100%, 30% 100%, 0 70%, 0 0)",
        }}
      >
        <KeyboardArrowUp />
      </Button>
    </Box>
  );
};

export default BackToTop;
